import axios from "axios";

export const BASE = "cat_insurance_policies";

/**
 * Busca un registro del catálogo de pólizas por su valor exacto.
 * Backend debe responder 200 con el objeto si existe y está activo, o 200 con body vacío/null si no.
 */
export const getByPolicy = (policy) => {
  return axios.get(`${BASE}/by-policy/${encodeURIComponent(policy)}`);
};
